export default "__VITE_ASSET__jeBWOFB2__"